import { inject, Injectable } from '@angular/core';
import { WINDOW } from '@core/services/window.service';
import { Observable } from 'rxjs';
import { shareReplay, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class IdleCallbackService {
    private window: Window = inject(WINDOW);

    private idle = this.idleCallBack(2000).pipe(take(1), shareReplay(1));

    constructor() {
        this.idle.subscribe();
    }

    idleCallBack(timeout: number = 1000): Observable<null> {
        return new Observable(observer => {
            if (this.window.requestIdleCallback) {
                this.window.requestIdleCallback(() => {
                    observer.next(null);
                    observer.complete();
                });
            } else {
                setTimeout(() => {
                    observer.next(null);
                    observer.complete();
                }, timeout);
            }
        });
    }

    firstIdleCallback() {
        return this.idle;
    }
}
